import * as React from 'react';

import classnames from 'classnames';

import {
    NUTSHELL_PRO_ANNUAL,
    NUTSHELL_PRO_MONTHLY,
    NUTSHELL_BUSINESS_ANNUAL,
    NUTSHELL_BUSINESS_MONTHLY,
    // @ts-expect-error
} from '../consts';
import type {Plan} from '../types';

import styles from './plan-picker-card-info-badge.module.css';

type Props = {
    plan: Plan;
};

export function PlanPickerCardInfoBadge(props: Props) {
    const badge = getBadge(props.plan);
    const styleName = classnames({
        [styles['badge-info']]: badge && badge.level === 'info',
        [styles['badge-success']]: badge && badge.level === 'success',
        [styles['badge-deprecated']]: badge && badge.level === 'deprecated',
    });

    return (
        <>
            {badge && (
                <div
                    className={classnames(
                        'pos-absolute pad-8 top-0 full-width text-align-center border-box',
                        styleName
                    )}
                >
                    {badge.text}
                </div>
            )}
        </>
    );
}

type Badge = {
    text: string;
    level: 'info' | 'success' | 'deprecated';
};

function getBadge(plan: Plan): Badge | null | undefined {
    if (plan.isLegacy) {
        return {
            text: 'No longer maintained',
            level: 'deprecated',
        };
    }

    switch (plan.code) {
        case NUTSHELL_PRO_MONTHLY:
        case NUTSHELL_PRO_ANNUAL:
            return {
                text: 'Most popular',
                level: 'info',
            };
        case NUTSHELL_BUSINESS_MONTHLY:
        case NUTSHELL_BUSINESS_ANNUAL:
            return {
                text: 'Best value',
                level: 'success',
            };
        default:
            return null;
    }
}
